import type { WorkflowSection } from '@ebalance/proto/bffuser/v1/workflow_template_model_pb'

import { usePersistedFilters } from '~/hooks/usePersistedFilters'
import {
  ADMIN_WORKFLOW_TEMPLATES_FILTERS_STORAGE_KEY,
  type AdminWorkflowTemplatesFilters,
  adminWorkflowTemplatesFiltersCodec,
} from '~/pages/AdminWorkflowTemplates/models/persistedFilters'

type UsePersistedWorkflowTemplateFiltersResult = {
  filterSection: WorkflowSection | null
  setFilterSection: (value: WorkflowSection | null) => void
  selectedTagLabels: Set<string>
  setSelectedTagLabels: (value: Set<string>) => void
}

/**
 * 業務区分・タグのフィルタを localStorage に保持し、再訪をまたいで復元する hook
 * (AC-SC-031 [P0])。
 *
 * 直列化・復元・既定値・検証は `models/persistedFilters.ts` の純関数が SoT。
 * 読み書きのタイミング (初期復元 / 変更時の書き戻し / 未操作の既定値は書かない /
 * Strict Mode 対策) は共通 hook が持つ。
 */
export function usePersistedWorkflowTemplateFilters(): UsePersistedWorkflowTemplateFiltersResult {
  const { filters, updateFilters } =
    usePersistedFilters<AdminWorkflowTemplatesFilters>({
      storageKey: ADMIN_WORKFLOW_TEMPLATES_FILTERS_STORAGE_KEY,
      codec: adminWorkflowTemplatesFiltersCodec,
    })

  return {
    filterSection: filters.filterSection,
    setFilterSection: (value) =>
      updateFilters((prev) => ({ ...prev, filterSection: value })),
    selectedTagLabels: filters.selectedTagLabels,
    // `DsMultiSelect` は次の Set をそのまま渡してくる (updater ではない)。
    setSelectedTagLabels: (value) =>
      updateFilters((prev) => ({ ...prev, selectedTagLabels: value })),
  }
}
